'use strict';
const angular = require('angular');

export class BCNavbarComponent {
  menu = [{
    title: 'Home',
    url: 'main'
  }];

  isCollapsed = true;

  constructor($state, $cookies, $scope, $rootScope, navService) {
    'ngInject';

    // this.isLoggedIn = FB.isLoggedInSync;
    // this.getCurrentUser = FB.getCurrentUserSync;
    // this.$firebaseAuth = $firebaseAuth();
    // this.$state = $state;
    // this.$cookies = $cookies;
    // this.isAdmin = FB.isAdminSync;
    // this.navService = navService;
    // console.log(this.isAdmin());

    // $scope.page = navService.getPage;


  }

  $onInit(){
   
  }
}

export default angular.module('appApp.bcnavbar', [])
  .directive('bcnavbar', function() {
    return {
      template: require('./bcnavbar.html'),
      controller: BCNavbarComponent,
      controllerAs:'bcnavbarCtrl',
      restrict: 'EA',
      link: function(scope, element, attrs) {}
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/directives/bcnavbar/bcnavbar.directive.js